module.exports = __webpack_public_path__ + "static/img/digtal5.23c10f4.gif";


//////////////////
// WEBPACK FOOTER
// ./public/visualImg/digtal5.gif
// module id = jrEI
// module chunks = 0